import { INFO_CLIENT } from 'config/constants/endpoints'

export async function getTokenPriceFromGraph(token: string): Promise<string> {
  try {
    const res = await fetch(INFO_CLIENT, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: `{"query":"{tokens(where:{id:\\"${token.toLowerCase()}\\"}){derivedUSD}}","variables":null}`,
    })
    const content = await res.json()

    return content?.data?.tokens[0]?.derivedUSD ?? '0'
  } catch (err) {
    console.warn('Failed to fetch token price from graph', err)
    return '0'
  }
}
